import HeroImage from "../assets/GTA-Main.webp";
import Avatars from "../assets/avatars2.webp";
import Btn from "../resuable-components/Button"
import { trackSignupEvent} from '../../../utlis/useAnalytics';


export default function Hero(){
    const btnClick = () => {
        trackSignupEvent({
          page: 'Global Trade Page',
          section: 'Hero SignUp',
        });
      };
    
    return(
        
        <div className="text-[#1A202C] flex flex-col lg:flex-row justify-between items-center lg:pl-[14%] lg:pr-[17%] md:mt-[170px] mt-[140px] px-[6%]  box-border">
        <div className="text-center md:text-left space-y-10 w-full lg:w-1/2 box-border px-0 md:px-4">
            <p className="font-bold text-3xl md:text-5xl text-center lg:text-left md:leading-[60px] font-inter">B2B Export Import Trade Payments</p>
            <p className="mt-4 text-[#6a7282] text-center lg:text-left md:mt-8 text-lg md:text-2xl font-inter">
                Enjoy <b className="text-[#27a887]">50%</b> better FX margins, streamline <b className="text-[#27a887]">BOE</b> and <b className="text-[#27a887]">Shipping Bill</b> regularization online, and generate <b className="text-[#27a887]">e-BRCs</b> effortlessly
            </p>
            <div className="flex justify-center lg:justify-start">
            <Btn onClick={btnClick}/>
            </div>
         
            <img src={Avatars} className=" w-[60%] w-[300px] lg:ml-[-2%] mx-auto lg:mx-0 mt-4 md:mt-10 " />
        </div>
        <div className="mt-8 md:mt-0 w-full md:w-1/2 flex justify-center box-border px-0 md:px-4">
            <img src={HeroImage} className="hover:scale-[105%] transition-transform duration-300 w-[90%] lg:w-[120%] mt-5 lg:mt-0 max-w-[120%]" />
        </div>
    </div>
    )
}